<template>
<v-container>
        <v-text-field v-model="search" placeholder="Rechercher un animal" prepend-inner-icon="mdi-magnify" append-icon="mdi-filter-variant" filled rounded dense class="mb-4" ></v-text-field>

        <v-row>
        <v-col cols="12" v-for="item in filteredList" :key="item.lst_id" class="pa-2">
            <v-hover v-slot="{ hover }">
                <v-card :elevation="hover ? 1 : 3" class="rounded-xl pa-4" style="cursor:pointer;" @click="$router.push({ path: '/livestocks/' + item.lst_id })">
                    <div class="d-flex align-center">
                        <v-icon size="60" :color="getIconColor(item)" class="mr-4">$sheep</v-icon>
                        <div class="flex-grow-1">
                        <div class="d-flex align-center">
                            <span class="text-h6 font-weight-bold mr-2 text-uppercase">
                            {{ item.lst_name }}
                            </span>
                            <v-icon :color="item.lst_sex === 'M' ? 'blue' : 'pink'">
                            {{ item.lst_sex === 'M' ? 'mdi-gender-male' : 'mdi-gender-female' }}
                            </v-icon>
                        </div>
                        
                        <div class="body-2 grey--text text--darken-2">
                            <strong>Site:</strong> {{ item.sit_name || item.sit_address || 'Aucun site' }}
                        </div>

                        <v-chip :small="!$root.$mobileView" :x-small="$root.$mobileView" class="ma-2" outlined :color="stateListById[item.lst_sta_id].sta_color">
                            Statut: {{ stateListById[item.lst_sta_id].sta_label }}
                        </v-chip>
                        </div>
                        <v-chip label outlined>{{(!$root.$mobileView) ? 'Né le :' : ''}} {{ $date(item.lst_birth_date).format('DD/MM/YYYY') }}</v-chip>
                        
                        <!--<router-link :to="($root.$permissions.Livestock.update) ? { name: 'livestocks-edit', params: { lst_id: item.lst_id } } : null">
                            <v-btn rounded color="light-green darken-1" dark depressed class="text-capitalize" >{{item.lst_birth_date}}</v-btn>
                        </router-link>-->
                    </div>
                </v-card>
            </v-hover>
        </v-col>
        </v-row>
        <v-alert v-if="filteredList.length === 0" type="error" class="mt-4">
        Aucun animal enregistré
        </v-alert>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useLivestockStore } from '@/stores/livestock'
import { useTypeStore } from '@/stores/type'
import { useStateStore } from '@/stores/state'

export default {
   name: 'livestocks-list',
   props: [ 'sitId', 'minView' ],
   computed: {
        ...mapState(useLivestockStore, {itemList: 'itemList' }),
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
        ...mapState(useStateStore, {stateListByGroup: 'itemListByGroup', stateListById: 'itemListById' }),
        filteredList() {
            if (!this.search) return this.itemList;
            
            const searchLower = this.search.toLowerCase();
            return this.itemList.filter(item => {
                return (
                item.lst_name.toLowerCase().includes(searchLower) ||
                item.lst_tag.toLowerCase().includes(searchLower) //|| item.lst_site.toLowerCase().includes(searchLower)
                );
            });
        }
   },
   data: function () {
       return {
           search: '',
           pagination: { totalItems: 0, rowsPerPage: 10, rowsPerItem: [15,25,35,{text:'Tout',value:-1}] },
           headers: [
               { text: 'Identification', value: 'lst_tag', align: 'left'},
               { text: 'Espèce', value: 'lst_typ_id', align: 'left'},
               { text: 'Race', value: 'lst_breed', align: 'left'},
               { text: 'Sexe', value: 'lst_sex', align: 'center'},
               { text: 'Statut', value: 'lst_sta_id', align: 'left'},
               { text: 'Action', value: 'lst_id', align: 'right'},
           ],
       }
   },
   async mounted () {
    if( this.minView ){
        this.headers = [
            { text: 'Nom', value: 'lst_name', align: 'left'},
            { text: 'Race', value: 'lst_breed', align: 'left'},
            { text: 'Sexe', value: 'lst_sex', align: 'center'},
        ]
    }

    let params = '?per_page=false'
    params    += (this.sitId) ? '&extended=withsite&sit_id=' + this.sitId : '&extended=withsite'
    await this.fetchItems(params)

   },
   methods: {
       ...mapActions(useLivestockStore, {fetchItems: 'fetchItems'}),
        // Gestion dynamique des couleurs de statut (Pastilles)
        getStatusColor(status) {
        switch (status.toLowerCase()) {
            case 'sain': return '#4CAF50'; // Vert
            case 'gestante': return '#FBC02D'; // Jaune/Orange
            case 'malade': return '#F44336'; // Rouge
            default: return '#9E9E9E'; // Gris
        }
        },
        // Gestion de la couleur de l'icône mouton
        getIconColor(item) {
            if (item.lst_sex == 'M') return 'blue lighten-2';
            if (item.lst_sex == 'F') return 'pink lighten-2';
            if (item.lst_name.includes('AGNEAU')) return 'green lighten-4';
        return 'grey lighten-3';
        }
   },
}
</script>